// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import { hot } from 'react-hot-loader'
import Masthead from '@ta-interaktiv/react-masthead'
import Footer from '../footer'
import { ThemeSwitch as themeSwitch } from '@ta-interaktiv/react-theme-switch'
import './styles.scss'
import UserFeedback from '@ta-interaktiv/react-user-feedback'
import ReactIframeResizer from 'react-iframe-resizer-super'

const ARTICLE_ID = '28480677'

class AppComponent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      publicationDate: Date.now() / 1000
    }

    themeSwitch({ mediaName: '24heures' })
  }

  componentDidMount () {
    /* const script = document.createElement('script')
    script.src = 'https://files.newsnetz.ch/scripts/dimension_watcher.js'
    script.async = true
    script.onload = () => {
      DimensionWatcher.enableParentNotification(
        function() {
          return $('body').width()
        },
        function() {
          return $('body').height()+0
        }
      )
    }
    document.body.appendChild(script) */
  }

  render () {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />

        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              L’ancrage des populismes en Europe
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
              De droite ou de gauche, les courants populistes se sont
              durablement inscrits dans le paysage européen. Démonstration en
              deux cartes
              </div>
            </h2>
            <p className='ta author'>
              Cathy Macherel
            </p>
          </div>
        </header>

        <figure
          className='illustration-wrapper ui container'
          style={{ marginBottom: '.15em' }}
        >
          <img
            alt='Illustration'
            src={require('./cover.jpg')}
          />
        </figure>

        <main className='ui vertical segment'>
          <div className='ui text container' style={{ position: 'relative' }}>
            <p style={{ marginTop: '2em' }}>
              Dans les années 1980 et jusqu’au milieu des années 1990, les succès
              électoraux des formations populistes sont considérés comme des
              phénomènes de contestation éphémères du système. Un exemple:
              lorsqu’en 1983, en France, le Front national obtient 11% des suffrages aux
              élections européennes, ce succès est analysé comme une «poussée de
              fièvre» caractéristique des mouvements de droite nationaliste, à l’instar du
              bonapartisme, du boulangisme ou du poujadisme, qui n’ont jamais réussi à
              percer durablement dans le paysage politique français. Or on sait
              aujourd’hui à quel point le parti des Le Pen influence le jeu politique dans
              l’Hexagone…
            </p>
            <p>
              Longtemps caractérisé par des performances électorales cycliques, «le
              national-populisme s’est installé durablement dans nombre de pays
              européens depuis vingt ans», relève le politologue Jean-Yves Camus
              (<a href='https://www.24heures.ch/21954495' target='_blanck'>lire
              son interview</a>). La critique de la désindustrialisation et de la mondialisation,
              ainsi que le refus d’un multiculturalisme amené par la mondialisation ont été
              le moteur de l’implantation de ce courant en Europe.
            </p>

            {/* <div className='blockquote-wrapper'>
              <blockquote>
                <p>Il s’agit d’entreprises internationales qui pèsent des milliards et face auxquels Swissmedic joue un rôle modeste.</p>
              </blockquote>
              <cite>– Stephan Kinzl</cite>
              </div> */}
            
            <p>
              La carte du national-populisme de 1998 à 2018, conçue à partir des
              scrutins législatifs, rend compte de manière tangible de cet enracinement
              toujours plus marqué. Il s’agit de l’ancrage de partis plaçant le peuple au
              centre du discours, s’affirmant par la critique systématique des élites et
              défendant la primauté du national sur l’international. Ces formations
              appartiennent à la famille des droites radicales, mais peuvent avoir des
              visions divergentes sur la politique économique ou présenter un degré
              d’europhobie plus ou moins marqué.
            </p>

            <aside
              className='ui vertical very fitted segment widescreen hidden large screen hidden small'
              style={{ marginBottom: '1em' }}
            >
              <a href='https://www.24heures.ch/monde/populisme/'>
                <div className='story-hint'>
                  <img src={require('./dossier.jpg')} style={{ width: '120px' }} />
                  <div className='hint-container'>
                    Retrouvez tous les articles de{' '}
                    <nobr>
                      <span className='pseudo-link'>notre dossier</span>
                    </nobr> spécial populisme.
                  </div>
                </div>
              </a>
            </aside>
            <aside
              className='ui right rail computer or lower hidden'
              style={{ top: '35%' }}
            >
              <a href='https://www.24heures.ch/monde/populisme/'>
                <div className='story-hint'>
                  <img src={require('./dossier.jpg')} style={{ width: '100%' }} />
                  <div className='hint-container'>
                    Retrouvez tous les articles de{' '}
                    <nobr>
                      <span className='pseudo-link'>notre dossier</span>
                    </nobr> spécial populisme.
                  </div>
                </div>
              </a>
            </aside>
          </div>

          <div className='ui container' style={{margin: '2em 0'}}>
            <ReactIframeResizer
              src={'https://interactif.24heures.ch/2019/02_19_populisme/map_boot_np.html'}
              style={{ width: '100%', minHeight: 20 }}
            />
          </div>

          <div className='ui text container' style={{ position: 'relative' }}>
            <p>
              Phénomène plus récent, des partis antiélites de gauche sont nés avec le
              discours critique de la rue sur les effets de la mondialisation. Ils se
              distinguent de la gauche traditionnelle par un positionnement antisystème
              radical. La formation Podemos en Espagne, issue de la mobilisation des
              Indignés, ou encore le succès de Syriza en Grèce, bâti sur les effets de la
              crise financière de 2010, en sont des exemples types. Mais à gauche le
              populisme se caractérise aussi par ses aspects protéiformes. En Italie,
              Cinque Stelle (le Mouvement Cinq Étoiles) est un parti attrape-tout qui
              s’est construit sur un discours terrien, où écologie et protectionnisme font la
              paire. Ce positionnement permet, parfois, des alliances avec les formations
              national-populistes. C’est le cas en Italie, même si la coalition au pouvoir
              Cinque Stelle-Lega se révèle chaotique, mais aussi en Slovaquie où le
              parti Smer a forgé son succès à travers une alliance rose-brune.
            </p>
          </div>

          <div className='ui container' style={{margin: '2em 0'}}>
            <ReactIframeResizer
              src={'https://interactif.24heures.ch/2019/02_19_populisme/map_boot_gp.html'}
              style={{ width: '100%', minHeight: 20 }}
            />
          </div>

          <div className='ui text container' style={{ position: 'relative' }}>
            <UserFeedback
              articleId={ARTICLE_ID}
              locale={'fr'}
              starColor={'red'}
              title='Comment évaluez-vous cet article'
              questions={[
                'Comment évaluez-vous l’utilité des cartes?',
                'Comment évaluez-vous la qualité du texte?',
                'Comment évaluez-vous l’utilité du texte?'
              ]}
            />
          </div>
        </main>

        <Footer
          articleId={ARTICLE_ID}
          publicationDate={this.state.publicationDate}
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
